import * as Yup from 'yup';

export const validationSchema: Yup.ObjectSchema<{}> = Yup.object().shape({
  accountId: Yup.string().required('Account selection is required.').nullable()
});
